import ParameterErrors from '../errors/ParameterErrors';
import AssetsManager from '../assets_management/AssetsManager';
import Iterator from '../core/Iterator';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
import exposeBinding from '../mvvm/exposeBinding';
import WhenFinishedModifying from '../core/WhenFinishedModifying';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsons{
	constructor(){
		enableAcceptBindings(this);
		this.initialize = this.initialize.bind(this);
		this._updateAllFeatures = this._updateAllFeatures.bind(this);
		this._whenFinishedModifyingSiteJsonAllFeatures = new WhenFinishedModifying({
			delay:0.1, callback:this._updateAllFeatures
		});
	}
	get entries(){
		return this._entries;
	}
	getPlotsArray(){
		let siteJsonUnitPlots = [];
		this._entries.forEach(siteJson=>{
			siteJsonUnitPlots = siteJsonUnitPlots.concat(siteJson.getPlotsArray());
		});
		return siteJsonUnitPlots;
	}
	
	get units(){
		let siteJsonUnits = [];
		this._entries.forEach(siteJson=>{
			siteJson.units.forEach(siteJsonUnit=>{
				if(siteJsonUnits.indexOf(siteJsonUnit)<0)
					siteJsonUnits.push(siteJsonUnit);
			});
		});
		return siteJsonUnits;
	}
	get houseTypes(){
		const entries = [];
		this._entries.forEach(siteJson=>{
			siteJson.houseTypes.forEach(houseType=>{
				if(entries.indexOf(houseType)<0)
					entries.push(houseType);
			});
		});
		return entries;
	}
	get allFeatures(){
		return this._allFeatures;
	}
	_updateAllFeatures(){
		const allFeatures = [];
		const seenIds = [];
		if(!this._entries)return;
		this._entries.forEach(siteJson=>{
			if(!siteJson.allFeatures)return;
			siteJson.allFeatures.forEach(feature=>{
				if(seenIds.indexOf(feature.id)<0){
					seenIds.push(feature.id);
					allFeatures.push(feature);
				}
			});
		});
		this._allFeatures = allFeatures;
		this.bindingsHandler.changed('allFeatures', this._allFeatures);
	}
	/*
	get models(){
		return this._models;
	}
	getPlotByNumber(plotNumber){
		return this.units.getPlotByNumber(plotNumber);
	}
	getPlotsForHouseType(houseType){
		return this.getPlotsArray().filter(plot=>plot.houseType===houseType);
	}*/
	get minPlotPrice(){
		let min = null;
		this.getPlotsArray().forEach(siteJsonUnitPlot=>{
			if(siteJsonUnitPlot.price===0||siteJsonUnitPlot.price===null||siteJsonUnitPlot.price===undefined) return;
			if(min===null)
				min = siteJsonUnitPlot.price;
			else 
				if(min>siteJsonUnitPlot.price)
					min = siteJsonUnitPlot.price;
		});
		return min;
	}
	get maxPlotPrice(){
		let max = null;
		this.getPlotsArray().forEach(siteJsonUnitPlot=>{
			if(max===null)
				max = siteJsonUnitPlot.price;
			else 
				if(max<siteJsonUnitPlot.price)
					max = siteJsonUnitPlot.price;
		});
		return max;
	}
	initialize(){
		return new Promise((resolve, reject)=>{
			const entries = [];
			const configurations = AssetsManager.configurations;
			const configurationsIterator = new Iterator(configurations.entries);
			const doNext = ()=>{
				if(!configurationsIterator.hasNext()){
					this._entries = entries;
					exposeBinding(this, 'allFeatures', ()=>this.allFeatures, (value)=>this.allFeatures = value);
					this._updateAllFeatures();
					resolve();
					return;
				}
				const configuration = configurationsIterator.next();
				AssetsManager.getSiteAssets(configuration).then(({siteJson})=>{
					entries.push(siteJson);
					PropertyBindingFactory.standard(this, siteJson, 'allFeatures', 
						this._whenFinishedModifyingSiteJsonAllFeatures.trigger);
					doNext();
				}).catch(reject);
			};
			doNext();
		});
	}
}